import { registerEnumType } from 'type-graphql'

export enum BlogTranscribingStatusEnum {
  idle = 'idle',
  waiting = 'waiting',
  active = 'active',
  completed = 'completed',
  failed = 'failed',
  delayed = 'delayed',
  cancelled = 'cancelled',
}

registerEnumType(BlogTranscribingStatusEnum, {
  name: 'BlogTranscribingStatusEnum',
  description: 'Status of blog video transcription process',
})
